import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import DetailedSingleBlog from "../../Component/DetailedSingleBlog/DetailedSingleBlog";
import Loading from "../../Component/Loading/Loading";
import RelatedBlogs from "../../Component/RelatedBlogs/RelatedBlogs";
import { fetchBlog } from "../../features/Blog/BlogSlice";

const BlogDetail = () => {
  const dispatch = useDispatch();
  const {blogId} = useParams();
  const {blog , isError, isLoading, error}= useSelector(state => state.blog);

  useEffect(() =>{
    dispatch(fetchBlog(blogId))
  },[dispatch, blogId])

  let content;

    if (isLoading) content = <Loading></Loading>

    if (!isLoading && isError) content = <div className="col-span-12">{error}</div>

    if (!isError && !isLoading && blog?.id) content= <div className="col-span-12">sorry! No video found.</div>

    if (!isError && !isLoading && blog?.id) content= <DetailedSingleBlog blog={blog}></DetailedSingleBlog>


  return (
    <>
      <div className="container mt-8">
        <Link
          to="/"
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
      </div>
      <section className="post-page-container">

        {/* <!-- detailed post  --> */}
        {content}

        {/* <!-- related posts --> */}
       <RelatedBlogs></RelatedBlogs>
      </section>
    </>
  );
};

export default BlogDetail;
